import { useState, type FormEvent } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import { ApiError } from '../api/client'
import { useAuth } from '../app/auth'
import { useRedeemOnboard } from './useOnboarding'

// Öffentliche Mitarbeiter-Registrierung per Einmal-ID: Code vom Chef eingeben, Benutzername + Passwort SELBST
// wählen. Bei Erfolg ist man direkt eingeloggt (Auto-Login) → ab in die App.
export function MemberOnboardingPage() {
  const { user, isLoading } = useAuth()
  const navigate = useNavigate()
  const redeem = useRedeemOnboard()
  const [code, setCode] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  if (!isLoading && user) return <Navigate to="/" replace />

  function onSubmit(e: FormEvent) {
    e.preventDefault()
    redeem.mutate(
      { code: code.trim(), username, password },
      { onSuccess: () => navigate('/', { replace: true }) },
    )
  }

  const errorMessage = redeem.error instanceof ApiError ? redeem.error.message : redeem.isError ? 'Registrierung fehlgeschlagen' : null

  return (
    <div className="centered">
      <form className="card login" onSubmit={onSubmit}>
        <h1>Mitarbeiter-Registrierung</h1>
        <p className="hint">Gib den Einmal-Code deines Chefs ein und lege deinen Benutzernamen und ein Passwort fest.</p>
        <label className="field">
          <span>Einmal-Code</span>
          <input
            name="code"
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
            placeholder="WF-XXXX-XXXX-XXXX-XXXX"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
          />
        </label>
        <label className="field">
          <span>Benutzername</span>
          <input
            name="username"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            value={username}
            onChange={(e) => setUsername(e.target.value.toLowerCase())}
          />
        </label>
        <label className="field">
          <span>Passwort (min. 8 Zeichen)</span>
          <input name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {errorMessage && (
          <p className="error" role="alert">
            {errorMessage}
          </p>
        )}
        <button type="submit" className="btn" disabled={redeem.isPending}>
          {redeem.isPending ? 'Konto wird angelegt…' : 'Konto anlegen'}
        </button>
        <nav className="wf-legalfoot" aria-label="Navigation">
          <Link to="/login">Zurück zur Anmeldung</Link>
        </nav>
      </form>
    </div>
  )
}
